// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "gf/css/" + chunkId + "." + "a927608780f9245ac511" + ".css";
};